/**
 * Update qty mobile - sticky bottom
 */

function updateQtyMobile() {
	let qtyCart = '0';

	if (document.querySelector('.mobile-cart .cart-count-bubble')) {
		qtyCart = document.querySelector('.cart-count-bubble span:first-child').innerText;
	}

	if (document.querySelector('.bottom-mobile_items .cart-count-bubble span')) {
		document.querySelector('.bottom-mobile_items .cart-count-bubble span').innerHTML = qtyCart;
	}
}

/**
 * Move content to mobile
 * Bidirectional: content moves into the mobile target below the breakpoint and
 * back into its original desktop slot above it, so resizing across 1024px
 * never loses the header cart controls.
 * Moves the live [data-target-content] node (never innerHTML copies): a string
 * copy recreates #cart-icon-bubble without the click listener cart-drawer.js
 * bound at load, so the cart link falls back to navigating to /cart.
 * The media query mirrors header.css's mobile-header breakpoint, so JS and CSS
 * can never disagree about which header is showing.
 */
const mobileHeaderQuery = window.matchMedia('(max-width: 1024px)');

function moveToMobile() {
	const isMobile = mobileHeaderQuery.matches;
	const contents = document.querySelectorAll('div[data-target-mobile]');

	contents.forEach((item) => {
		const target = document.getElementById(item.getAttribute('data-target-mobile'));
		if (!target) return;

		const content = item.querySelector('[data-target-content]') || target.querySelector('[data-target-content]');
		if (!content) return;

		if (isMobile && content.parentElement !== target) {
			target.replaceChildren(content);
		} else if (!isMobile && content.parentElement === target) {
			target.replaceChildren();
			item.appendChild(content);
		}
	});
}

/**
 * Bottom fixed bars (mobile bottom nav, PDP sticky add-to-cart): publish their
 * real border-box heights as CSS variables so body padding and stacking
 * offsets track content-driven height changes (wrapping variant labels,
 * breakpoint display toggles) instead of hardcoded guesses.
 * Same measure-into-variable pattern as --header-height. A hidden bar
 * (display: none) measures 0, so the variables are correct in every state.
 */
function observeBottomBars() {
	const bars = [
		['--sticky-atc-height', document.querySelector('.sticky-button-cart')],
		['--bottom-bar-height', document.querySelector('.sticky-bottom-mobile')],
	].filter(([, element]) => element);
	if (!bars.length) return;

	const setBarHeightVars = () => {
		bars.forEach(([name, element]) => {
			document.documentElement.style.setProperty(name, element.offsetHeight + 'px');
		});
	};

	const observer = new ResizeObserver(setBarHeightVars);
	bars.forEach(([, element]) => observer.observe(element));
}

/**
 * Header group height changes at runtime with no window resize event: the
 * announcement bar rewraps, its countdown digits change width, its dropdown
 * panel opens, a timer bar is closed. Observe both sections so --header-height
 * and the sticky trigger offsets are re-measured from the real boxes instead of
 * the load-time values. Same measure-into-variable pattern as the bottom bars
 * above. Every consumer of --header-height is position: fixed, so re-writing
 * the variable cannot resize an observed box - no feedback loop.
 */
function observeHeaderGroup() {
	const headerGroup = document.querySelector('.header-group');
	if (!headerGroup || typeof ResizeObserver === 'undefined') return;

	const observer = new ResizeObserver(refreshHeaderOffsets);
	headerGroup.querySelectorAll('.announcement-bar-section, .section-header').forEach((section) => {
		observer.observe(section);
	});
}

/**
 * Distance from the top of the DOCUMENT to an element. offsetTop measures from
 * the nearest POSITIONED ancestor, so its meaning changes with the positioning
 * scheme above it (on the home page the header section is lifted out of flow to
 * overlay the hero, which would make its own offsetTop collapse to 0 and pin
 * the header at the first scrolled pixel). rect.top + scrollY is the same
 * number on every template. Only valid while the element is not pinned - the
 * existing "not stuck" guards still apply.
 */
function documentTop(element) {
	return element.getBoundingClientRect().top + window.scrollY;
}

/**
 * get height header
 */
function getHeaderHeight() {
	const headerGroup = document.querySelector('.header-group');
	if (!headerGroup) return;
	// Sum the group's two sections rather than reading the group's own box: on
	// the home page the header section is out of flow (transparent overlay) so
	// the group measures the announcement bar alone, while --header-height must
	// keep meaning "bar + header" for the mobile nav and search popup offsets on
	// every template. Both wrappers are plain divs with no padding or border, so
	// the sum equals the group height everywhere else.
	const announcementSection = headerGroup.querySelector('.announcement-bar-section');
	const headerSection = headerGroup.querySelector('.section-header');
	const headerHeight =
		(announcementSection ? announcementSection.offsetHeight : 0) + (headerSection ? headerSection.offsetHeight : 0);
	headerGroup.style = '--header-height: ' + headerHeight + 'px';

	// Height of whichever header bar actually pins (desktop or mobile), for
	// sticky offsets (--sticky-header-height replaces the old eyeballed 7rem)
	const mobileBar = document.querySelector('.header-main-mobile');
	const desktopBar = document.querySelector('.section-header .header-main');
	const pinnedBar = mobileBar && mobileBar.offsetHeight > 0 ? mobileBar : desktopBar;
	if (pinnedBar) {
		document.documentElement.style.setProperty('--sticky-header-height', pinnedBar.offsetHeight + 'px');
	}
}

// Expose the document (content) width as a CSS variable on the root element so
// full-width pseudo-elements (mega menu background, horizontal filter bar and
// search borders) can break out of the page-width container. Set on
// documentElement so every component inherits it, and refresh on resize.
function setDocumentWidth() {
	document.documentElement.style.setProperty('--document-width', document.body.clientWidth + 'px');
}

// Measure the real viewport scrollbar width so the scroll-lock compensation
// (base.css: body.overflow-hidden / .open-modal body padding-right) matches
// the scrollbar that actually disappears: ~17px with classic scrollbars,
// 0 with macOS overlay scrollbars (a hardcoded value shifts the whole page
// there). Skipped while a drawer/modal has the page locked - the scrollbar
// is already hidden then and would measure 0.
function setScrollbarWidth() {
	if (
		document.body.classList.contains('overflow-hidden') ||
		document.documentElement.classList.contains('open-modal')
	) {
		return;
	}
	document.documentElement.style.setProperty(
		'--scrollbar-width',
		window.innerWidth - document.documentElement.clientWidth + 'px'
	);
}

let resizeTicking = false;

function handleResize() {
	getHeaderHeight();
	setDocumentWidth();
	setScrollbarWidth();
	resizeTicking = false;
}

// Only actual 1024px crossings need the header content moved - a media query
// change listener skips the per-resize work (and the resize bursts Chrome
// fires on tab restore) entirely. Same pattern as footerCollapseQuery below.
mobileHeaderQuery.addEventListener('change', moveToMobile);

window.addEventListener('resize', function () {
	if (!resizeTicking) {
		resizeTicking = true;
		requestAnimationFrame(handleResize);
	}
});

window.addEventListener('DOMContentLoaded', function () {
	/**
	 * Height header
	 */

	getHeaderHeight();

	moveToMobile();

	observeBottomBars();

	observeHeaderGroup();

	moveSizeChartToBody();

	setDocumentWidth();

	setScrollbarWidth();
});

/**
 * Change form customer sidebar
 */
document.querySelectorAll('.change-form-customer').forEach((element) => {
	element.addEventListener('click', (event) => changeFormCustomer(event, element));
});

function changeFormCustomer(event, element) {
	event.preventDefault();
	const modalTitle = element.getAttribute('data-form-title');
	const modalTarget = element.getAttribute('data-form-customer-target');
	const currentModal = element.closest('modal-content');
	const formCustomers = currentModal.querySelectorAll('.customer-form');

	currentModal.querySelector('.modal-title').innerHTML = modalTitle;

	formCustomers.forEach((form) => {
		form.style.display = 'none';
	});

	document.getElementById(modalTarget).style.display = 'block';
	document.getElementById(modalTarget).focus();
}

/**
 * Set top position modal search
 */
window.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.header-desktop')) {
		let headerDesktopHeight = document.querySelector('.header-desktop').offsetHeight;
		document.querySelector('.header-desktop .search-modal').style.top = headerDesktopHeight + 'px';
	}
});
/**
 * Section lazy load
 */
function sectionLazyLoad() {
	let parentSection = '';
	const section = document.querySelector('[data-lazyload="true"]');

	if (section) {
		parentSection = section.closest('.shopify-section');
	}

	if (section) {
		const elementId = section.getAttribute('id');
		const sectionId = elementId.substring(16);
		const urlFetchSectionId = window.Shopify.routes.root + '?section_id=' + sectionId;

		if (!section.classList.contains('loaded')) {
			section.classList.add('loaded');

			fetch(urlFetchSectionId)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					setTimeout(() => {
						sectionElement = responseHTML.querySelector('section[id^="shopify-section-"]');

						section.innerHTML = sectionElement.innerHTML;
						section.querySelectorAll('script').forEach((oldScriptTag) => {
							const newScriptTag = document.createElement('script');
							Array.from(oldScriptTag.attributes).forEach((attribute) => {
								newScriptTag.setAttribute(attribute.name, attribute.value);
							});
							newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
							oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
						});

						section.setAttribute('data-lazyload', 'false');

						/**
						 * Fix lazyload image with RTL layout
						 */
						if (parentSection && document.querySelector('body').classList.contains('layout-rtl')) {
							const imagesLazy = parentSection.querySelectorAll('img');

							imagesLazy.forEach((image) => {
								if (image.getAttribute('loading') == 'lazy') {
									image.setAttribute('loading', 'loaded');
								}
							});
						}
					}, 50);
				})
				.finally(() => {
					if (document.querySelector('[data-fancybox]')) {
						Fancybox.bind('[data-fancybox="gallery"]', {});
					}
				});
		}
	}
}

let defaultDocumentTop = 0;
const headerMobileEl = document.querySelector('.header-mobile');
let headerMobileTop = headerMobileEl ? documentTop(headerMobileEl) : 0;

function stickyHeaderMobile() {
	const headerMobile = document.querySelector('.header-mobile');
	const colorOnSlideshow = document.querySelector('.header-main-mobile').getAttribute('data-group-color');
	let currentDocumentTop = document.documentElement.scrollTop;

	if (currentDocumentTop < defaultDocumentTop && currentDocumentTop > headerMobileTop) {
		// Re-measure --sticky-header-height as the overlay activates: covers
		// desktop-to-mobile window resizes where the load-time measurement
		// came from the other header bar
		if (!headerMobile.classList.contains('header-mobile-sticky')) getHeaderHeight();
		headerMobile.classList.add('header-mobile-sticky');

		if (document.body.classList.contains('index')) {
			headerMobile.querySelector('.header-main-mobile').classList.remove(colorOnSlideshow);
		}

		defaultDocumentTop = currentDocumentTop;
		return;
	} else {
		headerMobile.classList.remove('header-mobile-sticky');

		if (document.body.classList.contains('index')) {
			headerMobile.querySelector('.header-main-mobile').classList.add(colorOnSlideshow);
		}

		defaultDocumentTop = currentDocumentTop;
		return;
	}
}


/**
 * Fix image lazyload with swiper slider and RTL layout
 */

const intersectionObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			entry.target.querySelectorAll('img').forEach((image) => {
				if (image.getAttribute('loading') == 'lazy') {
					image.setAttribute('loading', 'loaded');
				}
			});
		}
	});
});

if (document.querySelector('body').classList.contains('layout-rtl')) {
	const swiperSlider = document.querySelectorAll('swiper-slider');

	swiperSlider.forEach((slider) => {
		intersectionObserver.observe(slider);
	});
}

/**
 * End fix image lazyload with swipper slider
 */

/**
 * Dropdown megamenu mobile
 */

class DropdownMegamenuMobile extends HTMLElement {
	constructor() {
		super();
		this._onClick = this.showDropdownMegamenuMobile.bind(this);
		this.addEventListener('click', this._onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
	}

	showDropdownMegamenuMobile() {
		const btnDropdown = this;
		const menuItem = btnDropdown.closest('.menu-item');
		menuItem.classList.add('show-dropdown');

		setTimeout(function () {
			menuItem.classList.add('animate');
		}, 10);
	}
}

customElements.define('dropdown-megamenu-item', DropdownMegamenuMobile);

class BackDropdownMegamenu extends HTMLElement {
	constructor() {
		super();
		this._onClick = this.backToMegamenuItem.bind(this);
		this.addEventListener('click', this._onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
	}

	backToMegamenuItem() {
		const btnBack = this;
		const menuItem = btnBack.closest('.menu-item');
		menuItem.classList.remove('animate');

		setTimeout(function () {
			menuItem.classList.remove('show-dropdown');
		}, 300);
	}
}

customElements.define('back-to-item', BackDropdownMegamenu);

/**
 * Sticky product add to cart
 */
class StickyProductAddToCart extends HTMLElement {
	constructor() {
		super();

		this._btnChangeQty = this.querySelectorAll('.quantity__button');
		this._btnStickyAddCart = this.querySelector('.sticky-add-cart');

		this._btnStickyAddCart.addEventListener('click', this.addToCart);

		this._btnChangeQty.forEach((btn) => {
			btn.addEventListener('click', this.changeQty);
		});
	}

	disconnectedCallback() {
		this._btnStickyAddCart?.removeEventListener('click', this.addToCart);
		this._btnChangeQty?.forEach((btn) => {
			btn.removeEventListener('click', this.changeQty);
		});
	}

	changeQty() {
		const inputQty = this.closest('sticky-quantity-input').querySelector('[name="quantity"]');
		const mainInput = document.querySelector('product-info quantity-input [name="quantity"]');
		let stickyInputValue = parseInt(inputQty.value);

		if (this.getAttribute('name') == 'plus') {
			stickyInputValue = stickyInputValue + 1;
		} else {
			if (parseInt(inputQty.value) > 1) {
				stickyInputValue = stickyInputValue - 1;
			}
		}

		inputQty.value = stickyInputValue;
		mainInput.value = stickyInputValue;
	}

	addToCart() {
		this.classList.add('loading');
		document.querySelector('product-info product-form .product-form__submit').click();
	}
}

customElements.define('sticky-quantity-input', StickyProductAddToCart);

function showStickyAddCart() {
	const stickyAddCart = document.querySelector('.sticky-button-cart');
	// Queried per call, not cached: a re-rendered product form would leave a
	// cached node detached, whose rect reads 0 and force-shows the bar.
	const buyBox = document.querySelector('product-info product-form');
	if (!buyBox) return;

	// Show only once the buy box has fully scrolled above the viewport, and
	// hide again while any part of the footer group is visible - so at the
	// page bottom only the mobile bottom bar needs clearance (the ATC body
	// padding is gated on the same show-sticky-add-cart class).
	const pastBuyBox = buyBox.getBoundingClientRect().bottom <= 0;
	const footerGroup = document.querySelector('.footer-group');
	const footerInView = footerGroup ? footerGroup.getBoundingClientRect().top < window.innerHeight : false;
	const show = pastBuyBox && !footerInView;

	stickyAddCart.classList.toggle('active', show);
	document.body.classList.toggle('show-sticky-add-cart', show);
}


/**
 * Move modal sizechart to body
 */

function moveSizeChartToBody() {
	if (document.querySelector('[id="modal-size-chart"]')) {
		document.body.append(document.querySelector('[id="modal-size-chart"]'));
	}
}

/**
 * Back to top
 */

function toTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}


class BackToTop extends HTMLElement {
	constructor() {
		super();

		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', toTop);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', toTop);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			toTop();
		}
	}
}

customElements.define('back-to-top', BackToTop);

/**
 * Sticky header
 */

let offsetTopHeader = 0;
const sectionHeader = document.querySelector('.section-header');
if (sectionHeader) sectionHeader.style = '--main-header-height: ' + sectionHeader.offsetHeight + 'px';

if (document.querySelector('[data-header-sticky="true"]')) {
	offsetTopHeader = documentTop(document.querySelector('[data-header-sticky="true"]'));
}

const cachedScrollEls = {
	stickyAddCart: document.querySelector('.sticky-button-cart'),
	backToTop: document.querySelector('back-to-top'),
	btnNewsletter: document.querySelector('.newsletter-popup_button'),
	stickyBottom: document.querySelector('.sticky-bottom-mobile'),
	headerSticky: document.querySelector('[data-header-sticky="true"]'),
	headerStickyColor: document.querySelector('.header-main')?.getAttribute('data-group-color'),
	isIndex: document.body.classList.contains('index'),
};

/**
 * Re-measure the header height and sticky trigger offsets after the header
 * group changes height at runtime (announcement countdown bar closed,
 * announcement dropdown panel toggled). Offsets are only re-read while the
 * header is not stuck, because offsetTop is unreliable on fixed elements.
 */
function refreshHeaderOffsets() {
	getHeaderHeight();
	if (cachedScrollEls.headerSticky && sectionHeader && !sectionHeader.classList.contains('sticky-header')) {
		offsetTopHeader = documentTop(cachedScrollEls.headerSticky);
	}
	if (headerMobileEl && !headerMobileEl.classList.contains('header-mobile-sticky')) {
		headerMobileTop = documentTop(headerMobileEl);
	}
}
window.refreshHeaderOffsets = refreshHeaderOffsets;

let scrollTicking = false;

function handleScroll() {
	sectionLazyLoad();
	stickyHeaderMobile();

	if (cachedScrollEls.stickyAddCart) {
		showStickyAddCart();
	}

	const scrollY = window.scrollY;

	if (cachedScrollEls.backToTop) {
		cachedScrollEls.backToTop.classList.toggle('active', scrollY > 800);
	}

	const pastViewport = scrollY > window.innerHeight;
	cachedScrollEls.btnNewsletter?.classList.toggle('active', pastViewport);
	if (cachedScrollEls.stickyBottom) {
		document.body.classList.toggle('sticky-menu-bottom-active', pastViewport);
	}

	if (cachedScrollEls.headerSticky) {
		// scrollY > 0: when the header starts at the document top (e.g. the
		// countdown announcement bar is hidden once elapsed), offsetTopHeader
		// is 0 and "scrollY >= 0" alone would keep the header stuck forever -
		// the release branch (transparent overlay / on-slideshow logo) would
		// never run after the first scroll.
		if (scrollY >= offsetTopHeader && scrollY > 0) {
			sectionHeader.classList.add('sticky-header');
			if (cachedScrollEls.isIndex && cachedScrollEls.headerStickyColor) {
				headerMainContent.classList.remove(cachedScrollEls.headerStickyColor);
			}
		} else {
			sectionHeader.classList.remove('sticky-header');
			if (cachedScrollEls.isIndex && cachedScrollEls.headerStickyColor) {
				headerMainContent.classList.add(cachedScrollEls.headerStickyColor);
			}
		}
	}

	scrollTicking = false;
}

document.addEventListener('scroll', () => {
	if (!scrollTicking) {
		scrollTicking = true;
		requestAnimationFrame(handleScroll);
	}
});

var headerMainContainer = document.querySelector('.header-main');
var headerMainContent = document.querySelector('.header-main__content');

if (headerMainContainer) {
	headerMainContainer.addEventListener('mouseover', headermainMouseOver);
	headerMainContainer.addEventListener('mouseout', headermainMouseOut);
}

const headerMainColorSticky = headerMainContainer ? headerMainContainer.getAttribute('data-group-color') : null;

function headermainMouseOver() {
	if (!document.querySelector('.sticky-header') && document.body.classList.contains('index') && headerMainColorSticky) {
		headerMainContainer.classList.add('mouse-over');
		headerMainContent.classList.remove(headerMainColorSticky);
	}
}

function headermainMouseOut() {
	if (!document.querySelector('.sticky-header') && document.body.classList.contains('index') && headerMainColorSticky) {
		headerMainContainer.classList.remove('mouse-over');
		headerMainContent.classList.add(headerMainColorSticky);
	}
}

/**
 * FAQs group
 */

class GroupFaqs extends HTMLElement {
	constructor() {
		super();

		const faqSections = document.querySelectorAll('.faqs');

		faqSections.forEach((faqSection) => {
			const groupTitle = faqSection.querySelector('.faq-group-title').innerHTML;
			this.insertAdjacentHTML('beforeend', groupTitle);
		});
	}
}

customElements.define('group-faqs', GroupFaqs);

class FaqGroupItem extends HTMLElement {
	constructor() {
		super();

		this._onClick = this.scrollToFaqs.bind(this);
		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this._onClick);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.scrollToFaqs();
		}
	}

	scrollToFaqs() {
		const faqSectionId = this.getAttribute('data-section-id');
		const faqTop = document.getElementById(faqSectionId).offsetTop;
		let fixOffsetTop = 0;

		if (window.innerWidth >= 1024) {
			fixOffsetTop = 60;
		}
		window.scrollTo({
			top: faqTop - fixOffsetTop,
			behavior: 'smooth',
		});
	}
}

customElements.define('faq-group-item', FaqGroupItem);

/**
 * View more
 */
class ViewMore extends HTMLElement {
	constructor() {
		super();

		this._onClick = this.viewMore.bind(this);
		this.addEventListener('click', this._onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
	}

	viewMore() {
		this.classList.toggle('active');
		this.closest('.has-more').classList.toggle('active');
	}
}

customElements.define('view-more', ViewMore);

/**
 * Close newsletter
 */
class CloseNewsletter extends HTMLElement {
	constructor() {
		super();

		if (!sessionStorage.getItem('closeNewsletter')) {
			this.closest('.newsletter-popup_button').style.display = 'block';
		}

		this._onClick = this.closeNewsletter.bind(this);
		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this._onClick);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.closeNewsletter();
		}
	}

	closeNewsletter() {
		this.closest('.newsletter-popup_button').style.display = 'none';
		sessionStorage.setItem('closeNewsletter', 'true');
	}
}

customElements.define('close-newsletter', CloseNewsletter);

/**
 * Mobile footer: menu columns collapse under their headings. Delegated so it
 * works regardless of when the section renders. On desktop the columns are
 * always open, so the buttons drop their disclosure semantics and leave the
 * tab order instead of announcing a collapsed state over visible content.
 */
const footerCollapseQuery = window.matchMedia('(max-width: 749px)');

function syncFooterToggles() {
	document.querySelectorAll('.footer-heading-toggle').forEach((toggle) => {
		const item = toggle.closest('.footer-block--collapsible');
		if (footerCollapseQuery.matches) {
			toggle.removeAttribute('tabindex');
			toggle.setAttribute('aria-expanded', String(Boolean(item && item.classList.contains('is-open'))));
		} else {
			toggle.setAttribute('tabindex', '-1');
			toggle.removeAttribute('aria-expanded');
		}
	});
}

footerCollapseQuery.addEventListener('change', syncFooterToggles);
document.addEventListener('DOMContentLoaded', syncFooterToggles);
document.addEventListener('shopify:section:load', syncFooterToggles);

document.addEventListener('click', (event) => {
	const toggle = event.target.closest('.footer-heading-toggle');
	if (!toggle || !footerCollapseQuery.matches) return;
	const item = toggle.closest('.footer-block--collapsible');
	if (!item) return;
	event.preventDefault();
	const expanded = toggle.getAttribute('aria-expanded') === 'true';
	toggle.setAttribute('aria-expanded', String(!expanded));
	item.classList.toggle('is-open', !expanded);
});

/**
 * Upsell minicart
 */

function upsellNoProduct() {
	const noProductData = '<div class="upsell-no-product">' + window.upsellProduct.noProduct + '</div>';
	const upsellCartContent = document.getElementById('upsell-ajax-load');
	const upsellcartBottom = document.getElementById('cart-drawer_upsell-bottom');

	if (upsellCartContent) {
		upsellCartContent.innerHTML = noProductData;
	}

	if (upsellcartBottom) {
		upsellcartBottom.innerHTML = noProductData;
	}
}

function upsellCartDrawer() {
	const lastIdProductAdded = localStorage.getItem('lastProductAdded');

	// No product reference yet (fresh visit, cleared storage, or a cart carried over
	// from a previous session): fetching with product_id=null 422s, so fall back to
	// the empty-upsell state instead of making a doomed request.
	if (!lastIdProductAdded || lastIdProductAdded === 'null') {
		upsellNoProduct();
		return;
	}

	const urlRecommend = document.querySelector('cart-drawer').getAttribute('data-recommendations-url');
	const upsellCartUrl = urlRecommend + '&product_id=' + lastIdProductAdded;

	fetch(upsellCartUrl)
		.then((response) => response.text())
		.then((responseText) => {
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			const upsellHtml = responseHTML.getElementById('shopify-section-upsell-cart');

			const upsellCartContent = document.getElementById('upsell-ajax-load');
			const upsellcartBottom = document.getElementById('cart-drawer_upsell-bottom');

			upsellCartContent.innerHTML = upsellHtml.innerHTML;

			/**
			 * Append upsell to mobile
			 */
			upsellcartBottom.innerHTML = upsellHtml.innerHTML;

			upsellcartBottom.querySelectorAll('.product-buttons').forEach((item) => {
				item.remove();
			});

			upsellcartBottom.querySelectorAll('.product-image-buttons').forEach((item) => {
				item.remove();
			});

			upsellCartContent.querySelectorAll('script').forEach((oldScriptTag) => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach((attribute) => {
					newScriptTag.setAttribute(attribute.name, attribute.value);
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});
		})
		.finally(() => {
			const checkItem = document.querySelector('#upsell-ajax-load .product-card-wrapper');

			if (!checkItem) {
				upsellNoProduct();
			}
		})
		.catch(() => {
			upsellNoProduct();
		});
}

/**
 * Update label sticky cart product page
 */

function getStickyVariantValue(fieldset) {
	const checked = fieldset.querySelector('input[type="radio"]:checked');
	if (checked) return checked.value;
	const select = fieldset.querySelector('select');
	if (select) return select.value;
	return '';
}

function updateStickyCartLabel() {
	if (document.querySelector('.sticky-button-cart') && document.querySelector('.main-product-section variant-selects')) {
		const productVariants = document.querySelectorAll('.main-product-section variant-selects fieldset.product-form__input');
		const variantLabelContainer = document.querySelectorAll('.sticky-cart_variants');

		variantLabelContainer.forEach((variantContent) => {
			variantContent.innerHTML = '';
		});

		productVariants.forEach((variant) => {
			const value = getStickyVariantValue(variant);
			if (!value) return;
			variantLabelContainer.forEach((variantContent) => {
				const label = document.createElement('div');
				label.className = 'variant-label';
				label.textContent = value;
				variantContent.appendChild(label);
			});
		});
	}
}

updateStickyCartLabel();

// Keep the sticky bar's price, image and add-to-cart button in sync with the
// selected variant. ProductInfo publishes variantChange with the freshly
// fetched section html (which includes the sticky bar) plus the variant.
function updateStickyCartInfo(event) {
	const stickyBar = document.querySelector('.sticky-button-cart');
	if (!stickyBar) return;

	const html = event?.data?.html;
	const variant = event?.data?.variant;

	// Price (server-rendered for the selected variant in the fetched section)
	const newPrice = html?.querySelector('.sticky-button-cart .sticky-product_price');
	const currentPrice = stickyBar.querySelector('.sticky-product_price');
	if (newPrice && currentPrice) currentPrice.innerHTML = newPrice.innerHTML;

	// Add-to-cart button: availability + label
	const newButton = html?.querySelector('.sticky-button-cart .sticky-add-cart');
	const currentButton = stickyBar.querySelector('.sticky-add-cart');
	if (newButton && currentButton) {
		currentButton.toggleAttribute('disabled', newButton.hasAttribute('disabled'));
		const newText = newButton.querySelector('.btn-text');
		const currentText = currentButton.querySelector('.btn-text');
		if (newText && currentText) currentText.innerHTML = newText.innerHTML;
	}

	// Image: use the variant's featured media when it has one
	const mediaSrc = variant?.featured_media?.preview_image?.src;
	const stickyImage = stickyBar.querySelector('.product-image img');
	if (mediaSrc && stickyImage) {
		stickyImage.src = mediaSrc.replace(/(\.\w+)(\?|$)/, '_80x$1$2');
		stickyImage.srcset = '';
	}
}

// Keep the sticky bar's variant values in sync when a different variant is chosen.
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
	subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, updateStickyCartLabel);
	subscribe(PUB_SUB_EVENTS.variantChange, updateStickyCartInfo);
}

/**
 * Upsell Minicart
 */

if (!customElements.get('upsell-minicart')) {
	customElements.define(
		'upsell-minicart',
		class UpsellCart extends HTMLElement {
			constructor() {
				super();

				if (document.querySelector('.cart-upsell-container') && document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty') == false && document.querySelector('.cart-drawer_upsell-bottom')) {
					upsellCartDrawer();
				}
			}
		}
	);
}

/**
 * Toggle password
 */

if (!customElements.get('toggle-password')) {
	customElements.define(
		'toggle-password',
		class TogglePassword extends HTMLElement {
			constructor() {
				super();

				this._onClick = this.togglePassword.bind(this);
				this._onKeyPress = this.keyPress.bind(this);
				this.addEventListener('click', this._onClick);
				this.addEventListener('keypress', this._onKeyPress);
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick);
				this.removeEventListener('keypress', this._onKeyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.togglePassword();
				}
			}

			togglePassword() {
				if (this.closest('.input-password').classList.contains('active')) {
					this.closest('.input-password').classList.remove('active');
					this.closest('.input-password').querySelector('input[type="text"]').setAttribute('type', 'password');
					return;
				} else {
					this.closest('.input-password').classList.add('active');
					this.closest('.input-password').querySelector('input[type="password"]').setAttribute('type', 'text');
					return;
				}
			}
		}
	);
}

/**
 * Slideshow scroll button
 */

class SlideShowScroll extends HTMLElement {
	constructor() {
		super();

		this._onClick = this.slideScroll.bind(this);
		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this._onClick);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.slideScroll();
		}
	}

	slideScroll() {
		const section = this.closest('.section');
		const scrollValue = section.offsetTop + section.offsetHeight;
		window.scrollTo({ top: scrollValue, behavior: 'smooth' });
	}
}

customElements.define('slideshow-scroll', SlideShowScroll);

/**
 * Section animation
 */

if (!customElements.get('animation-section')) {
	customElements.define(
		'animation-section',
		class Animation extends HTMLElement {
			constructor() {
				super();

				this.elementRender = this.querySelector('[data-lazyload-element]');
			}

			connectedCallback() {
				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					setTimeout(() => {
						this.classList.add('animated');
					}, 500);
				};

				this._observer = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px -300px 0px' });
				this._observer.observe(this);
			}

			disconnectedCallback() {
				this._observer?.disconnect();
			}
		}
	);
}
